/** Totals (a day, a month) read to the cent. */
export const TOTAL_DECIMALS = 2;

/** A single conversation, turn or call costs fractions of a cent. */
export const UNIT_DECIMALS = 3;
